/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/DashboardPageBlockImage'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./DashboardPageBlockImage'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DashboardPageExportSettings = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.DashboardPageBlockImage);
  }
}(this, function(ApiClient, DashboardPageBlockImage) {
  'use strict';




  /**
   * The DashboardPageExportSettings model module.
   * @module model/DashboardPageExportSettings
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>DashboardPageExportSettings</code>.
   * @alias module:model/DashboardPageExportSettings
   * @class
   */
  var exports = function() {
    var _this = this;












  };

  /**
   * Constructs a <code>DashboardPageExportSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DashboardPageExportSettings} obj Optional instance to populate.
   * @return {module:model/DashboardPageExportSettings} The populated <code>DashboardPageExportSettings</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('DashboardPageID')) {
        obj['DashboardPageID'] = ApiClient.convertToType(data['DashboardPageID'], 'Integer');
      }
      if (data.hasOwnProperty('PageOrientationID')) {
        obj['PageOrientationID'] = ApiClient.convertToType(data['PageOrientationID'], 'Integer');
      }
      if (data.hasOwnProperty('InsightPeriodID')) {
        obj['InsightPeriodID'] = ApiClient.convertToType(data['InsightPeriodID'], 'Integer');
      }
      if (data.hasOwnProperty('InsightCustomPeriodStart')) {
        obj['InsightCustomPeriodStart'] = ApiClient.convertToType(data['InsightCustomPeriodStart'], 'Date');
      }
      if (data.hasOwnProperty('InsightCustomPeriodEnd')) {
        obj['InsightCustomPeriodEnd'] = ApiClient.convertToType(data['InsightCustomPeriodEnd'], 'Date');
      }
      if (data.hasOwnProperty('IsPrivate')) {
        obj['IsPrivate'] = ApiClient.convertToType(data['IsPrivate'], 'Boolean');
      }
      if (data.hasOwnProperty('CoverLetter')) {
        obj['CoverLetter'] = ApiClient.convertToType(data['CoverLetter'], 'String');
      }
      if (data.hasOwnProperty('FileName')) {
        obj['FileName'] = ApiClient.convertToType(data['FileName'], 'String');
      }
      if (data.hasOwnProperty('TaggedUserIDs')) {
        obj['TaggedUserIDs'] = ApiClient.convertToType(data['TaggedUserIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('BlockImages')) {
        obj['BlockImages'] = ApiClient.convertToType(data['BlockImages'], [DashboardPageBlockImage]);
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} DashboardPageID
   * @default 0
   */
  exports.prototype['DashboardPageID'] = 0;
  /**
   * @member {Integer} PageOrientationID
   * @default 0
   */
  exports.prototype['PageOrientationID'] = 0;
  /**
   * @member {Integer} InsightPeriodID
   * @default 0
   */
  exports.prototype['InsightPeriodID'] = 0;
  /**
   * @member {Date} InsightCustomPeriodStart
   */
  exports.prototype['InsightCustomPeriodStart'] = undefined;
  /**
   * @member {Date} InsightCustomPeriodEnd
   */
  exports.prototype['InsightCustomPeriodEnd'] = undefined;
  /**
   * @member {Boolean} IsPrivate
   * @default false
   */
  exports.prototype['IsPrivate'] = false;
  /**
   * @member {String} CoverLetter
   * @default ''
   */
  exports.prototype['CoverLetter'] = '';
  /**
   * @member {String} FileName
   * @default ''
   */
  exports.prototype['FileName'] = '';
  /**
   * @member {Array.<Integer>} TaggedUserIDs
   */
  exports.prototype['TaggedUserIDs'] = undefined;
  /**
   * @member {Array.<module:model/DashboardPageBlockImage>} BlockImages
   */
  exports.prototype['BlockImages'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


